import {OWN_CLUB_NAME} from '../config';
import {GameData, MatchFilter} from '../types';
import {MONTH_NAMES, parseLocalDateTime} from '../utils/date';

export const isOwnTeam = (name: string) => name.includes(OWN_CLUB_NAME);

export const gameKey = (game: GameData) => `${game.termin}|${game.heim}|${game.auswaerts}|${game.bewerb_kurz}`;

/** Removes the round suffix volleynet appends to some competition names. */
export const competitionName = (bewerb: string) => bewerb.replace(/ (Süd )?Grunddurchgang/, '');

/** Games that haven't started yet, earliest first. */
export function upcomingGames(games: GameData[], now = new Date()): GameData[] {
    return games
        .map(game => ({game, start: parseLocalDateTime(game.termin).getTime()}))
        .filter(({start}) => start > now.getTime())
        .sort((a, b) => a.start - b.start)
        .map(({game}) => game);
}

/** One filter per competition in `games`, in order of first appearance. */
export function competitionFilters(games: GameData[]): MatchFilter[] {
    const filters = new Map<string, MatchFilter>();
    for (const game of games) {
        if (game.bewerb_kurz && !filters.has(game.bewerb_kurz)) {
            filters.set(game.bewerb_kurz, {
                filter_name: game.bewerb_kurz,
                display_name: competitionName(game.bewerb || game.bewerb_kurz),
            });
        }
    }
    return Array.from(filters.values());
}

/** Keeps the games of the selected competitions; an empty selection keeps all games. */
export const filterByCompetition = (games: GameData[], competitions: string[]) =>
    competitions.length ? games.filter(game => competitions.includes(game.bewerb_kurz)) : games;

export interface MonthGroup {
    /** "YYYY-MM" */
    key: string;
    /** e.g. "Oktober 2026" */
    label: string;
    games: GameData[];
}

/** Splits date-sorted games into consecutive months. */
export function groupByMonth(games: GameData[]): MonthGroup[] {
    const groups: MonthGroup[] = [];
    for (const game of games) {
        const key = game.termin.slice(0, 7);
        let group = groups[groups.length - 1];
        if (group?.key !== key) {
            const date = parseLocalDateTime(game.termin);
            group = {key, label: `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`, games: []};
            groups.push(group);
        }
        group.games.push(game);
    }
    return groups;
}
